module.exports = __webpack_public_path__ + "static/media/bathroom-4.cd1eca91.jpg";